import { Bubble } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { barrel_config } from "./configs/barrel_config";
import ChartJSDataLabel from "chartjs-plugin-datalabels";
import { Chart as CJS } from "chart.js"

export const BubbleChart = ({ data, config }) => {
  CJS.register(ChartJSDataLabel)
  return (
    <Bubble data={data} {...config} />
  );
};

export const BarrelChart = ({data}) => {
  let labels = new Set()
  const colorMap = {
      "Barrel": "#ed1b24",
      "Flare-or-Burner": "#f8cbac",
      "Poorly-Topped": "#e2efdb",
      "Poorly-Under": "#ddebf6",
      "Solid-Contact": "#fdcfd1",
      "Weak-Contact": "#fff2cd",
      "Poorly-Weak": "#fff2cd"
  }
  const packPointData = (data, borderWidth) => {
    let dt = []
    for (const i in data) {
      dt.push({
        pointBackgroundColor: colorMap[i],
        borderWidth: borderWidth,
        borderColor: "#000000",
        data: data[i],
        label: i,
      })
      labels.add(i)
    }
    return {dt, labels}
  }
  const wrapPointData = (personal, borderWidth) => {
    let pdata = packPointData(personal, borderWidth)
    return {
      labels: Array.from(pdata.labels),
      datasets: pdata.dt
    }
  }
  return (
    <>
      <div className="chart_barrel" style={{ background: "none" }}>
        <BubbleChart data={wrapPointData(data)} config={barrel_config} />
        <div class="chart_barrel_legend">
          <div class="barrel_br_list"></div> Barrel<br />
          <div class="barrel_fb_list"></div> Flare-or-Burner<br />
          <div class="barrel_pt_list"></div> Topped<br />
          <div class="barrel_pu_list"></div> Under<br />
          <div class="barrel_sc_list"></div> Solid-Contact<br />
          <div class="barrel_wc_list"></div> Weak-Contact<br />
          <div class="barrel_wc_list"></div> Poorly-Weak<br />
        </div>
      </div>
    </>
  )
}